module.exports = __webpack_public_path__ + "static/media/22.222d3617.jpg";